import { memo, FC, SVGProps } from "react"

export const ProxyCrossIcon: FC<SVGProps<SVGSVGElement>> = memo((props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="2.5" cy="2.5" r="2.5" />
      <circle cx="21.5" cy="2.5" r="2.5" />
      <circle cx="21.5" cy="21.5" r="2.5" />
      <circle cx="2.5" cy="21.5" r="2.5" />
      <circle cx="8.5" cy="15.5" r="2.5" />
      <circle cx="15.5" cy="15.5" r="2.5" />
      <circle cx="15.5" cy="8.5" r="2.5" />
      <circle cx="8.5" cy="8.5" r="2.5" />
    </svg>
  )
})
export default ProxyCrossIcon
